// React
import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';

// Misc
import { posthog } from '../lib/posthog';

export const usePostHogPageview = () => {
  const pathname = useRouterState({
    select: (s) => s.location.pathname,
  });

  useEffect(() => {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: pathname,
    });
  }, [pathname]);
};
